<template>
  <div class="corner-box w-14 h-8 relative rounded-sm flex items-center justify-center text-sm font-semibold">
    <slot />
  </div>
</template>

<style scoped>
.corner-box::before {
  content: '';
  position: absolute;
  inset: 0;
  border: 2px solid transparent;
  border-radius: inherit;
  mask:
    linear-gradient(#fff 0 0) padding-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  -webkit-mask-composite: source-out;
  mask-clip: padding-box, border-box;
  background:
    linear-gradient(currentColor, currentColor) top left,
    linear-gradient(currentColor, currentColor) top right,
    linear-gradient(currentColor, currentColor) bottom left,
    linear-gradient(currentColor, currentColor) bottom right;
  background-size: 10px 10px;
  background-origin: border-box;
  background-repeat: no-repeat;
}
</style>
